export default "__VITE_PUBLIC_ASSET__80ba6cfd__"